import { BehaviorSubject, Observable } from 'rxjs';

export class MeasurementDeviceBaseService {
  #capturingThicknessInProgressSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public isAwaitingForThicknessResult(): Observable<boolean> {
    return this.#capturingThicknessInProgressSubject;
  }

  public thicknessDataReceived(): void {
    this.#capturingThicknessInProgressSubject.next(false);
  }

  public thicknessCapturingStarted(): void {
    this.#capturingThicknessInProgressSubject.next(true);
  }
}
